import React, { useEffect } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Navigation from "./components/Navigation";
import Footer from "./components/Footer";
import Home from "./pages/Home";
import About from "./pages/About";
import Awards from "./pages/Awards";
import Speaking from "./pages/Speaking";
import Luminarc from "./pages/Luminarc";
import Insights from "./pages/Insights";
import Contact from "./pages/Contact";
import Themes from "./pages/Themes";
import AdminLogin from "./pages/admin/Login";
import AdminDashboard from "./pages/admin/Dashboard";
import AuthCallback from "./pages/admin/AuthCallback";
import Loader from "./components/experience/Loader";
import Cursor from "./components/experience/Cursor";
import TopTicker from "./components/experience/TopTicker";
import { AuthProvider, useAuth } from "./context/AuthContext";
import { Toaster } from "./components/ui/sonner";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
  }, [pathname]);
  return null;
}

function RevealObservers({ children }) {
  const { pathname } = useLocation();
  useEffect(() => {
    const els = document.querySelectorAll(".rise, .rule-draw, .split-word");
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) {
            e.target.classList.add("in");
            io.unobserve(e.target);
          }
        });
      },
      { threshold: 0.14 }
    );
    els.forEach((el) => io.observe(el));
    return () => io.disconnect();
  }, [pathname]);
  return <>{children}</>;
}

function AdminGate() {
  const { user, loading } = useAuth();
  if (loading) {
    return (
      <main className="min-h-[70vh] bg-[var(--cream)] text-[var(--ink)] flex items-center justify-center">
        <div className="tag-mono">Checking session…</div>
      </main>
    );
  }
  if (!user) return <AdminLogin />;
  if (!user.is_admin) return <AdminLogin notAdmin />;
  return <AdminDashboard />;
}

function AppRouter() {
  const location = useLocation();
  // Synchronously intercept OAuth callback
  if (location.hash && location.hash.includes("session_id=")) {
    return <AuthCallback />;
  }

  const isAdmin = location.pathname.startsWith("/admin");

  return (
    <>
      {!isAdmin && <TopTicker />}
      {!isAdmin && <Navigation />}
      <RevealObservers>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/awards" element={<Awards />} />
          <Route path="/speaking" element={<Speaking />} />
          <Route path="/luminarc" element={<Luminarc />} />
          <Route path="/insights" element={<Insights />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/themes" element={<Themes />} />
          <Route path="/admin" element={<AdminGate />} />
        </Routes>
      </RevealObservers>
      {!isAdmin && <Footer />}
    </>
  );
}

function App() {
  return (
    <div className="App">
      <Loader />
      <BrowserRouter>
        <AuthProvider>
          <Cursor />
          <ScrollToTop />
          <AppRouter />
          <Toaster />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
